<template>
	<div style="z-index: 9999;">
  
	  <div class="needGZ_TanWrap tan_needGz_portraitWrap" style="z-index: 9999;" v-if="true && tan_needGZ_single && allData">
		
		<!-- <div class="needGZ_Tan bgF3F4F7 needGZ_One_Tan" style="width: 924px;overflow: hidden;"> -->
		<!-- <div class="needGZ_Tan bgF3F4F7 needGZ_One_Tan" style="width: 924px;overflow: hidden;max-height: none;" v-show="isDomOver"> -->
		<div class="needGZ_Tan bgF3F4F7 needGZ_One_Tan" style="width: 924px;overflow: hidden;max-height: none; border-radius: 16px;" v-show="true">
		  
			<div style="display: flex; height: 65px; position: relative;">
				<img style="position: absolute; width: 100%; height: 65px;"
					src="../../../assets/icon_dean_home_alert_bg_2.png" alt="">
				<div
					style="position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; justify-content: space-between; align-items: center;">
					<div style="display: flex; align-items: center; height: 100%;">
						<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px;">
						</div>
						<div
							style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 20px;">
							{{ allData.buAndFlName || '' }}</div>
					</div>
					<img style="width: 36px; height: 36px; margin-right: 15px; cursor: pointer;"
						src="../../../assets/icon_common_close_1.png" alt=""
						@click="tan_needGZ_single = false" />
				</div>
			</div>
			
  
  
		  <!-- <div class="needGZ_Cont portrait_Cont" style="max-height: 730px;overflow: auto;"> -->
		  <div class="needGZ_Cont portrait_Cont" :style="{maxHeight: innerHeight + 'px',overflow: 'auto'}">
			<img class="szhxNoBg" src="../../../assets/szhxNo.png" v-if="!allData.isStart"/>
			<img class="szhxNoBg" src="../../../assets/szhxNo1.png" v-if="allData.isStart && allData.breathInfo.unSecretsDays && allData.breathInfo.unSecretsDays.remainDays == 1"/>
			<img class="szhxNoBg" src="../../../assets/szhxNo2.png" v-if="allData.isStart && allData.breathInfo.unSecretsDays && allData.breathInfo.unSecretsDays.remainDays == 2"/>
			<div v-if="allData.isStart && allData.breathInfo.clickFlag == 3">
			  <div class="portrait_topWrap" v-if="!allData.breathInfo.unSecretsDays">
				<img class="szhxNo3_1" src="../../../assets/icon_dean_home_alert_icon_8.png"/>
				<img class="szhxNo3_2" src="../../../assets/icon_dean_home_alert_icon_9.png"/>
				<div>&nbsp;</div>
				<div class="hx_overview1" v-html="$options.filters.reMate(allData.summarize)"></div>
				<!-- <div class="hx_overview">
				  芬达发大水发发生
				  <div class="bot_adv_tag">
					<img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
					<span>哈哈</span>
				  </div>
				  <div class="bot_adv_tag">
					<img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
					<span>哈发建档立卡减肥的哈</span>
				  </div>
				  <div class="bot_adv_tag">
					<img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
					<span>哈发建档立卡减肥的哈</span>
				  </div>
				  芬达发大水发发生芬达发大水发发生芬达发大水发发生
				  <div class="bot_adv_tag">
					<img class="tanhaoIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png"/>
					<span>哈发建档立卡减肥的哈</span>
				  </div>
				</div> -->
				<img class="szhxNo3_3" src="../../../assets/icon_dean_home_alert_icon_10.png"/>
			  </div>
			  <!-- 发现几项值得关注的变化 -->
			  <div class="gzVaryWrap" v-if="allData.changeNum">
				<img class="gBellImg" src="../../../assets/ai_icon_news_d@2x.png" alt="">
				<div class="name">发现</div>
				<div class="name colorFF7186" style="font-weight: bold;">{{  allData.changeNum }}</div>
				<div class="name">项值得关注的变化</div>
			  </div>
			  <div class="needGZ_OneListWrap">
				<!-- 呼吸情况 -->
				<div class="needGZ_OneList" v-if="true">
				  <!-- 未揭秘的进度条 -->
				  <div class="needGZ_OneListNoJm" v-if="allData.breathInfo.unSecretsDays">
					<div class="noJm_speed" :style="{width: allData.breathInfo.unSecretsDays.accDays/allData.breathInfo.unSecretsDays.totalDays + '%'}"></div>
				  </div>
				  <!-- 上方内容 -->
				  <div class="portrait_OneList_topWrap" @click="hxqk_isExpand = !hxqk_isExpand">
					<div class="portrait_OneList_top">
					  <div class="szhx_IconWrap">
						<img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_11.png" alt="">
					  </div>
					  <div class="szhx_nameNum" v-if="allData.breathInfo.changeNum">
						<div class="num">{{ allData.breathInfo.changeNum }}</div>
					  </div>
					  <div class="flex_Cen_Cen" v-if="allData.breathInfo.hasOccurPrfList">
						<div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.breathInfo.hasOccurPrfList">
						  <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
						  <div class="fList fListRed" v-if="item.isNew && item.isWarn">
							<img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
							{{ item.realValue }}
						  </div>
						</div>
					  </div>
					  
					  <div class="flex mlAuto" v-if="allData.breathInfo.unSecretsDays">
						<div>再有</div>
						<div class="color1890ff">{{ allData.breathInfo.unSecretsDays.remainDays }}</div>
						<div>晚揭秘</div>
					  </div>
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!allData.breathInfo.unSecretsDays && !hxqk_isExpand">
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="!allData.breathInfo.unSecretsDays && hxqk_isExpand">
					</div>
				  </div>
				  <!-- 弹窗展开内容 -->
				  <div class="oneExpandCont" v-show="!allData.breathInfo.unSecretsDays && hxqk_isExpand" style="background: #E4E9EF;">
					<!-- 昨晚是否有值得关注的变化 -->
					<tan_needGz_portrait_isHaveChange v-if="allData.breathInfo.deviateTheDay" :haveChangeData="allData.breathInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
					<!-- 呼吸率分布如下图 -->
					<div class="txjyWrap border_no mt10">
					  <div class="txjyTit txjyTit_after_blue" style="">呼吸率分布</div>
					  <div class="referVal">
						<div class="referValLeft">
						  <div class="gangKuai2_border"></div>
						  <div class="gantTip">参考范围</div>
						</div>
						<div class="referValRight">
						  <div class="gantTip">横轴为呼吸率(次/分)</div>
						</div>
					  </div>
					  <div id="ech_breathOne" style="height: 150px;"></div>
					  <div class="refer_comTit mt15" v-if="allData.breathInfo.secretsBreath">{{ allData.breathInfo.secretsBreath.descLabel }}</div>
  
					  <!-- 是否发生偏离 -->
					  <tan_needGz_portrait_botZheCont v-if="allData.breathInfo.secretsBreathDeviate" :haveChangeData="allData.breathInfo.secretsBreathDeviate"></tan_needGz_portrait_botZheCont>
					</div>
					<!-- <div style="height:200px;background: red;;"></div> -->
					<!-- 吸呼比分布 -->
					<div class="txjyWrap border_no mt10">
					  <div class="txjyTit txjyTit_after_blue mt15" style="">吸呼比分布</div>
					  <div class="referVal">
						<div class="referValLeft">
						  <div class="gangKuai2_border"></div>
						  <div class="gantTip">参考范围</div>
						</div>
						<div class="referValRight">
						  <div class="gantTip">横轴为吸呼比</div>
						</div>
					  </div>
					  <div id="ech_breathTwo" style="height: 150px;"></div>
					  <div class="refer_comTit mt15" v-if="allData.breathInfo.secretsInExRatio">{{ allData.breathInfo.secretsInExRatio.descLabel }}</div>
  
					  <!-- 是否发生偏离 -->
					  <tan_needGz_portrait_botZheCont v-if="allData.breathInfo.secretsInExRatioDeviate" :haveChangeData="allData.breathInfo.secretsInExRatioDeviate"></tan_needGz_portrait_botZheCont>
  
					</div>
					
					<!-- 最下面的提醒建议 -->
					<tan_needGz_portrait_botAdvise :haveChangeData="allData.breathInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
				  
  
					
				  </div>
				</div>
  
				<!-- 体动情况 -->
				<div class="needGZ_OneList" v-if="true">
				  <!-- 未揭秘的进度条 -->
				  <div class="needGZ_OneListNoJm" v-if="allData.bodyMoveInfo.unSecretsDays">
					<div class="noJm_speed" :style="{width: allData.bodyMoveInfo.unSecretsDays.accDays/allData.bodyMoveInfo.unSecretsDays.totalDays + '%'}"></div>
				  </div>
				  <!-- 上方内容 -->
				  <div class="portrait_OneList_topWrap" @click="tdqk_isExpand = !tdqk_isExpand">
					<div class="portrait_OneList_top">
					  <div class="szhx_IconWrap">
						<img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_12.png" alt="">
					  </div>
					  <div class="szhx_nameNum" v-if="allData.bodyMoveInfo.changeNum">
						<div class="num">{{ allData.bodyMoveInfo.changeNum }}</div>
					  </div>
					  <div class="flex_Cen_Cen" v-if="allData.bodyMoveInfo.hasOccurPrfList">
						<div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.bodyMoveInfo.hasOccurPrfList">
						  <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
						  <div class="fList fListRed" v-if="item.isNew && item.isWarn">
							<img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
							{{ item.realValue }}
						  </div>
						</div>
					  </div>
  
					  <div class="flex mlAuto" v-if="allData.bodyMoveInfo.unSecretsDays">
						<div>再有</div>
						<div class="color1890ff">{{ allData.bodyMoveInfo.unSecretsDays.remainDays }}</div>
						<div>晚揭秘</div>
					  </div>
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!allData.bodyMoveInfo.unSecretsDays && !tdqk_isExpand">
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="!allData.bodyMoveInfo.unSecretsDays && tdqk_isExpand">
					</div>
				  </div>
				  <!-- 弹窗展开内容 -->
				  <div class="oneExpandCont" v-show="!allData.bodyMoveInfo.unSecretsDays && tdqk_isExpand" style="background: #E4E9EF;">
					<!-- 昨晚是否有值得关注的变化 -->
					<tan_needGz_portrait_isHaveChange v-if="allData.bodyMoveInfo.deviateTheDay" :haveChangeData="allData.bodyMoveInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
					
					<!-- 体动指数分布 -->
					<div class="txjyWrap border_no mt10">
					  <div class="txjyTit txjyTit_after_blue" style="">体动指数分布</div>
					  <div class="referVal">
						<div class="referValLeft">
						  <div class="gangKuai2_border"></div>
						  <div class="gantTip">参考范围</div>
						</div>
						<div class="referValRight">
						  <div class="gantTip">横轴为体动指数</div>
						</div>
					  </div>
					  <div id="ech_tdOne" style="height: 150px;"></div>
					  <div class="refer_comTit mt15" v-if=allData.bodyMoveInfo.secretsBodyMoveIndex>{{ allData.bodyMoveInfo.secretsBodyMoveIndex.descLabel }}</div>
  
					</div>
					<!-- 体动指数分布统计_折线 -->
					<div class="txjyWrap border_no mt10">
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">每晚体动指数</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">日常表现</div>
						  </div>
						</div>
						<div id="ech_td_line" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.bodyMoveInfo.secretsBodyMoveIndexDay">{{ allData.bodyMoveInfo.secretsBodyMoveIndexDay.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.bodyMoveInfo.secretsBodyMoveIndexDayDeviate" :haveChangeData="allData.bodyMoveInfo.secretsBodyMoveIndexDayDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
					
					<!-- 最下面的提醒建议 -->
					<tan_needGz_portrait_botAdvise :haveChangeData="allData.bodyMoveInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
					
  
					
				  </div>
				</div>
  
				<!-- 心跳情况 -->
				<div class="needGZ_OneList" v-if="false">
				  <!-- 未揭秘的进度条 -->
				  <div class="needGZ_OneListNoJm" v-if="allData.heartInfo.unSecretsDays">
					<div class="noJm_speed" :style="{width: allData.heartInfo.unSecretsDays.accDays/allData.heartInfo.unSecretsDays.totalDays + '%'}"></div>
				  </div>
				  <!-- 上方内容 -->
				  <div class="portrait_OneList_topWrap" @click="xtqk_isExpand = !xtqk_isExpand">
					<div class="portrait_OneList_top">
					  <div class="szhx_IconWrap">
						<img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_13.png" alt="">
					  </div>
					  <div class="szhx_nameNum" v-if="allData.heartInfo.changeNum">
						<div class="num">{{ allData.heartInfo.changeNum }}</div>
					  </div>
					  <div class="flex_Cen_Cen" v-if="allData.heartInfo.hasOccurPrfList">
						<div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.heartInfo.hasOccurPrfList">
						  <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
						  <div class="fList fListRed" v-if="item.isNew && item.isWarn">
							<img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
							{{ item.realValue }}
						  </div>
						</div>
					  </div>
					  <div class="flex mlAuto" v-if="allData.heartInfo.unSecretsDays">
						<div>再有</div>
						<div class="color1890ff">{{ allData.heartInfo.unSecretsDays.remainDays }}</div>
						<div>晚揭秘</div>
					  </div>
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!xtqk_isExpand && !allData.heartInfo.unSecretsDays">
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="xtqk_isExpand && !allData.heartInfo.unSecretsDays">
					</div>
				  </div>
				  <!-- 弹窗展开内容 -->
				  <div class="oneExpandCont" v-show="!allData.heartInfo.unSecretsDays && xtqk_isExpand" style="background: #E4E9EF;">
					<!-- 昨晚是否有值得关注的变化 -->
					<tan_needGz_portrait_isHaveChange v-if="allData.heartInfo.deviateTheDay" :haveChangeData="allData.heartInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
					<!-- 心率分布 -->
					<div class="txjyWrap border_no mt10">
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">心率分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为心率(次/分)</div>
						  </div>
						</div>
						<div id="ech_heartOne" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.heartInfo.secretsHeart">{{ allData.heartInfo.secretsHeart.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.heartInfo.secretsHeartDeviate" :haveChangeData="allData.heartInfo.secretsHeartDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
  
					<!-- 最下面的提醒建议 -->
					<tan_needGz_portrait_botAdvise :haveChangeData="allData.heartInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
  
					
				  </div>
				</div>
  
				<!-- 作息规律 -->
				<div class="needGZ_OneList" v-if="true">
				  <!-- 未揭秘的进度条 -->
				  <div class="needGZ_OneListNoJm" v-if="allData.dailyRoutineInfo.unSecretsDays">
					<div class="noJm_speed" :style="{width: allData.dailyRoutineInfo.unSecretsDays.accDays/allData.dailyRoutineInfo.unSecretsDays.totalDays + '%'}"></div>
				  </div>
				  <!-- 上方内容 -->
				  <div class="portrait_OneList_topWrap" @click="zxgl_isExpand = !zxgl_isExpand">
					<div class="portrait_OneList_top">
					  <div class="szhx_IconWrap">
						<img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_14.png" alt="">
					  </div>
					  <div class="szhx_nameNum" v-if="allData.dailyRoutineInfo.changeNum">
						<div class="num">{{ allData.dailyRoutineInfo.changeNum }}</div>
					  </div>
					  <div class="flex_Cen_Cen" v-if="allData.dailyRoutineInfo.hasOccurPrfList">
						<div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.dailyRoutineInfo.hasOccurPrfList">
						  <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
						  <div class="fList fListRed" v-if="item.isNew && item.isWarn">
							<img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
							{{ item.realValue }}
						  </div>
						</div>
					  </div>
					  <div class="flex mlAuto" v-if="allData.dailyRoutineInfo.unSecretsDays">
						<div>再有</div>
						<div class="color1890ff">{{ allData.dailyRoutineInfo.unSecretsDays.remainDays }}</div>
						<div>晚揭秘</div>
					  </div>
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!zxgl_isExpand && !allData.dailyRoutineInfo.unSecretsDays">
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="zxgl_isExpand && !allData.dailyRoutineInfo.unSecretsDays">
					</div>
				  </div>
				  <!-- 弹窗展开内容 -->
				  <div class="oneExpandCont" v-show="!allData.dailyRoutineInfo.unSecretsDays && zxgl_isExpand" style="background: #E4E9EF;">
					<!-- 昨晚是否有值得关注的变化 -->
					<tan_needGz_portrait_isHaveChange v-if="allData.dailyRoutineInfo.deviateTheDay" :haveChangeData="allData.dailyRoutineInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
					<!-- 上床入睡醒来起床 -->
					<div class="txjyWrap border_no mt10">
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">上床、入睡、醒来、起床时间点分布</div>
						<!-- <div class="lcscSinWrap">
						  <div class="name">离床时长（分钟）</div>
						  <img class="boxBg mt5" src="../../../assets/report_pic_color_d@2x.png" alt="">
						  <div class="boxBgData">
							<div class="bNum" :key="index" v-for="(item,index) in 11">{{index}}</div>
						  </div>
						</div> -->
						<div class="referVal referValTimeSingle">
						  <div class="referValLeft">
							<div class="gantTip">19:30</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">08:30</div>
						  </div>
						</div>
						<div id="id_echSanDian_wrap" style="height: 300px;overflow: auto;" v-if="allData && allData.dailyRoutineInfo && allData.dailyRoutineInfo.secretsDailyRoutine">
						  <div id="echSanDian" :style="{height:allData.dailyRoutineInfo.secretsDailyRoutine.data.length*42 + 'px'}"></div>
						</div>
  
						<!-- 作息规律显示这个 -->
						<div v-if="allData.dailyRoutineInfo.secretsDailyRoutine">
						  <div class="zxSanWrap mt10">
							<div class="zxSanList">上床</div>
							<div class="zxSanList">入睡</div>
							<div class="zxSanList">醒来</div>
							<div class="zxSanList">起床</div>
						  </div>
						  <div class="zxSanBotCont mt20">
							<div class="zxSanBotListWrap mb10" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2">
							  <div class="zxSanBotList">
								<div class="flex_Cen_Cen pt15">
								  <div class="zxBoxBlock"></div>
								  <div class="zxBoxName ml5">上床时间高频范围</div>
								</div>
								<div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedEd }}</div>
								<div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.getBedSt">暂无</div>
							  </div>
							  <div class="zxSanBotList">
								<div class="flex_Cen_Cen pt15">
								  <div class="zxBoxBlock bgFFEAD4"></div>
								  <div class="zxBoxName ml5">入睡时间高频范围</div>
								</div>
								<div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStEd }}</div>
								<div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepStSt">暂无</div>
							  </div>
							  <div class="zxSanBotList">
								<div class="flex_Cen_Cen pt15">
								  <div class="zxBoxBlock bgC6F3E9"></div>
								  <div class="zxBoxName ml5">醒来时间高频范围</div>
								</div>
								<div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdEd }}</div>
								<div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.sleepEdSt">暂无</div>
							  </div>
							  <div class="zxSanBotList">
								<div class="flex_Cen_Cen pt15">
								  <div class="zxBoxBlock bgB9DDFF"></div>
								  <div class="zxBoxName ml5">起床时间高频范围</div>
								</div>
								<div class="flex_Cen_Cen mt5" v-if="allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt">{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt }}～{{ allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedEd }}</div>
								<div class="flex_Cen_Cen mt5" v-if="!allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime.leaveBedSt">暂无</div>
							  </div>
							</div>
							<div class='' v-if="allData.dailyRoutineInfo.secretsDailyRoutine">{{ allData.dailyRoutineInfo.secretsDailyRoutine.descLabel }}</div>
						  </div>
						</div>
  
						<!-- 夜间离床显示这个 -->
						<!-- <div>
						  <div class="lcTimeTip mt10">
							<div class="lcTimeKuang"></div>
							<div class="lcTimeFont ml5">离床时间高频范围</div>
						  </div>
						  <div class="refer_comTit mt15" style="height: 66px;line-height: 22px;">
							<div>·通常会在01:12～02:13，05:18～05:58离床；·</div>
							<div class="flex">
							  <div>·</div>
							  <div class="colorFF7186">01:12～02:13</div>
							  <div>这个时间段发生的离床是值得注意的。·</div>
							</div>
						  </div>
						</div> -->
					  </div>
					</div>
					<!-- 入睡时长分布、统计如下图 -->
					<div class="txjyWrap border_no mt10">
					  <!-- 入睡时长分布 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">入睡时长分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为入睡时长(分钟)</div>
						  </div>
						</div>
						<div id="ech_sleepOne" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsSleep">{{ allData.dailyRoutineInfo.secretsSleep.descLabel }}</div>
					  </div>
					  <!-- 入睡时长统计 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue mt15" style="">每晚入睡时长</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">日常表现</div>
						  </div>
						</div>
						<div id="ech_sleepTwo" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsSleepDay">{{ allData.dailyRoutineInfo.secretsSleepDay.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.dailyRoutineInfo.secretsSleepDayDeviate" :haveChangeData="allData.dailyRoutineInfo.secretsSleepDayDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
					<!-- 起床时长分布、统计如下图 -->
					<div class="txjyWrap border_no mt10">
					  <!-- 起床时长分布 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">起床时长分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为起床时长(分钟)</div>
						  </div>
						</div>
						<div id="ech_getUpOne" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsBed">{{ allData.dailyRoutineInfo.secretsBed.descLabel }}</div>
					  </div>
					  <!-- 起床时长统计 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue mt15" style="">每晚起床时长</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">日常表现</div>
						  </div>
						</div>
						<div id="ech_getUpTwo" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.dailyRoutineInfo.secretsBed">{{ allData.dailyRoutineInfo.secretsBedDay.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.dailyRoutineInfo.secretsBedDayDeviate" :haveChangeData="allData.dailyRoutineInfo.secretsBedDayDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
					
					<!-- 最下面的提醒建议 -->
					<tan_needGz_portrait_botAdvise :haveChangeData="allData.dailyRoutineInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
  
					
				  </div>
				</div>
  
				<!-- 夜间离床 -->
				<div class="needGZ_OneList" v-if="true">
				  <!-- 未揭秘的进度条 -->
				  <div class="needGZ_OneListNoJm" v-if="allData.leaveBedInfo.unSecretsDays">
					<div class="noJm_speed" :style="{width: allData.leaveBedInfo.unSecretsDays.accDays/allData.leaveBedInfo.unSecretsDays.totalDays + '%'}"></div>
				  </div>
				  <!-- 上方内容 -->
				  <div class="portrait_OneList_topWrap" @click="yjlc_isExpand = !yjlc_isExpand">
					<div class="portrait_OneList_top">
					  <div class="szhx_IconWrap">
						<img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_15.png" alt="">
					  </div>
					  <div class="szhx_nameNum" v-if="allData.leaveBedInfo.changeNum">
						<div class="num">{{ allData.leaveBedInfo.changeNum }}</div>
					  </div>
					  <div class="flex_Cen_Cen" v-if="allData.leaveBedInfo.hasOccurPrfList">
						<div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.leaveBedInfo.hasOccurPrfList">
						  <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
						  <div class="fList fListRed" v-if="item.isNew && item.isWarn">
							<img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
							{{ item.realValue }}
						  </div>
						</div>
					  </div>
					  <div class="flex mlAuto" v-if="allData.leaveBedInfo.unSecretsDays">
						<div>再有</div>
						<div class="color1890ff">{{ allData.leaveBedInfo.unSecretsDays.remainDays }}</div>
						<div>晚揭秘</div>
					  </div>
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!yjlc_isExpand && !allData.leaveBedInfo.unSecretsDays">
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="yjlc_isExpand && !allData.leaveBedInfo.unSecretsDays">
					</div>
				  </div>
				  <!-- 弹窗展开内容 -->
				  <div class="oneExpandCont" v-show="!allData.leaveBedInfo.unSecretsDays && yjlc_isExpand" style="background: #E4E9EF;">
					<!-- 昨晚是否有值得关注的变化 -->
					<tan_needGz_portrait_isHaveChange v-if="allData.leaveBedInfo.deviateTheDay" :haveChangeData="allData.leaveBedInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
					<!-- 离床次数分布、统计如下图 -->
					<div class="txjyWrap border_no mt10">
					  <!-- 离床次数分布 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">离床次数分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为离床次数(次)</div>
						  </div>
						</div>
						<div id="ech_outBedNumOne" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedTimes">{{ allData.leaveBedInfo.secretsLeaveBedTimes.descLabel }}</div>
					  </div>
					  <!-- 离床次数统计 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue mt15" style="">每晚离床次数</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">日常表现</div>
						  </div>
						</div>
						<div id="ech_outBedNumTwo" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedTimesDay">{{ allData.leaveBedInfo.secretsLeaveBedTimesDay.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedTimesDayDeviate" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedTimesDayDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
					<!-- 离床时长分布、统计如下图 -->
					<div class="txjyWrap border_no mt10" v-if="allData.leaveBedInfo.secretsLeaveBedDuration">
					  <!-- 离床时长分布 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">离床时长分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为离床时长(分钟)</div>
						  </div>
						</div>
						<div id="ech_outBedTimeOne" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.leaveBedInfo.secretsLeaveBedDuration">{{ allData.leaveBedInfo.secretsLeaveBedDuration.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedDurationDeviate" :datatype="'lcscfb'" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedDurationDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
					<!-- 上床入睡醒来起床 -->
					<div class="txjyWrap border_no mt10" v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration">
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">离床发生的时间点和时长分布</div>
						<div class="lcscSinWrap mt10">
						  <div class="name" style="width:100%;text-align:center;">离床时长（分钟）</div>
						  <img class="boxBg mt5" src="../../../assets/report_pic_color_d@2x.png" alt="">
						  <div class="boxBgData" v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration">
							<div class="bNum" :key="index" v-for="(item,index) in allData.leaveBedInfo.secretsLeaveBedTimeDuration.referenceList">
							  <div v-if="item < 90">{{item}}</div>
							  <div v-if="item >= 90">≥{{item}}</div>
							</div>
						  </div>
						</div>
						<div class="referVal referValTimeSingle">
						  <div class="referValLeft">
							<div class="gantTip">19:30</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">08:30</div>
						  </div>
						</div>
						
						<div id="id_echSanDian_nightOutBed" style="height: 300px;overflow: auto;" v-if="allData && allData.leaveBedInfo && allData.leaveBedInfo.secretsLeaveBedTimeDuration">
						  <div id="echSanDian_nightOutBed" :style="{height:allData.leaveBedInfo.secretsLeaveBedTimeDuration.data.length*42 + 'px'}"></div>
						</div>
						
  
						<!-- 夜间离床显示这个 -->
						<div>
						  <div class="lcTimeTip mt10">
							<div class="lcTimeKuang"></div>
							<div class="lcTimeFont ml5">离床时间高频范围</div>
						  </div>
						  <div class="refer_comTit mt15" style="line-height: 22px;">
							<div v-if="allData.leaveBedInfo.secretsLeaveBedTimeDuration" v-html="$options.filters.reMate(allData.leaveBedInfo.secretsLeaveBedTimeDuration.descLabel)"></div>
							<!-- <div>·通常会在01:12～02:13，05:18～05:58离床；·</div>
							<div class="flex">
							  <div>·</div>
							  <div class="colorFF7186">01:12～02:13</div>
							  <div>这个时间段发生的离床是值得注意的。·</div>
							</div> -->
						  </div>
						</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.leaveBedInfo.secretsLeaveBedTimeDurationDeviate" :datatype="'lcSdt'" :haveChangeData="allData.leaveBedInfo.secretsLeaveBedTimeDurationDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
  
					<!-- 最下面的提醒建议 -->
					<tan_needGz_portrait_botAdvise :haveChangeData="allData.leaveBedInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
  
					
				  </div>
				</div>
				
				<!-- 睡眠情况 -->
				<div class="needGZ_OneList" v-if="true">
				  <!-- 未揭秘的进度条 -->
				  <div class="needGZ_OneListNoJm" v-if="allData.sleepInfo.unSecretsDays">
					<div class="noJm_speed" :style="{width: allData.sleepInfo.unSecretsDays.accDays/allData.sleepInfo.unSecretsDays.totalDays + '%'}"></div>
				  </div>
				  <!-- 上方内容 -->
				  <div class="portrait_OneList_topWrap" @click="smqk_isExpand = !smqk_isExpand">
					<div class="portrait_OneList_top">
					  <div class="szhx_IconWrap">
						<img class="szhx_Icon" src="../../../assets/icon_dean_home_alert_icon_16.png" alt="">
					  </div>
					  <div class="szhx_nameNum" v-if="allData.sleepInfo.changeNum">
						<div class="num">{{ allData.sleepInfo.changeNum }}</div>
					  </div>
					  <div class="flex_Cen_Cen" v-if="allData.sleepInfo.hasOccurPrfList">
						<div class="flex_Cen_Cen" :key="index" v-for="(item,index) in allData.sleepInfo.hasOccurPrfList">
						  <div class="fList" v-if="item.isNew && !item.isWarn" :style="{paddingLeft: !item.isWarn ? '10px' : '5px'}">{{ item.realValue }}</div>
						  <div class="fList fListRed" v-if="item.isNew && item.isWarn">
							<img class="fListIcon" src="https://ql-data-prd.oss-cn-beijing.aliyuncs.com/WeChat/QL/img/image/report_icon_notice_d@2x.png" alt="">
							{{ item.realValue }}
						  </div>
						</div>
					  </div>
					  <div class="flex mlAuto" v-if="allData.sleepInfo.unSecretsDays">
						<div>再有</div>
						<div class="color1890ff">{{ allData.sleepInfo.unSecretsDays.remainDays }}</div>
						<div>晚揭秘</div>
					  </div>
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x.png" alt="" v-if="!smqk_isExpand && !allData.sleepInfo.unSecretsDays">
					  <img class="report_detail_icon_down_h" src="../../../assets/report_detail_icon_down_h@2x2.png" alt="" v-if="smqk_isExpand && !allData.sleepInfo.unSecretsDays">
					</div>
				  </div>
				  <!-- 弹窗展开内容 -->
				  <div class="oneExpandCont" v-show="!allData.sleepInfo.unSecretsDays && smqk_isExpand" style="background: #E4E9EF;">
					<!-- 昨晚是否有值得关注的变化 -->
					<tan_needGz_portrait_isHaveChange v-if="allData.sleepInfo.deviateTheDay" :haveChangeData="allData.sleepInfo.deviateTheDay"></tan_needGz_portrait_isHaveChange>
					
					<!-- 睡眠时长分布、统计 -->
					<div class="txjyWrap border_no mt10">
					  <!-- 睡眠时长分布 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">睡眠时长分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为睡眠时长(小时)</div>
						  </div>
						</div>
						<div id="ech_sleepTimeOne" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepDuration">{{ allData.sleepInfo.secretsSleepDuration.descLabel }}</div>
					  </div>
					  <!-- 睡眠时长统计 -->
					  <div>
						<div class="refer_comLine_heng"></div>
						<div class="txjyTit txjyTit_after_blue mt15" style="">每晚睡眠时长</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">日常表现</div>
						  </div>
						</div>
						<div id="ech_sleepTimeTwo" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepDurationDay">{{ allData.sleepInfo.secretsSleepDurationDay.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepDurationDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepDurationDayDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
  
					<!-- 睡眠效率分布、统计 -->
					<div class="txjyWrap border_no mt10">
					  <!-- 睡眠效率分布 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">睡眠效率分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为睡眠效率(%)</div>
						  </div>
						</div>
						<div id="ech_sleepEffOne" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepEfficiency">{{ allData.sleepInfo.secretsSleepEfficiency.descLabel }}</div>
					  </div>
					  <!-- 睡眠效率统计 -->
					  <div>
						<div class="refer_comLine_heng"></div>
						<div class="txjyTit txjyTit_after_blue mt15" style="">每晚睡眠效率：</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">日常表现</div>
						  </div>
						</div>
						<div id="ech_sleepEffTwo" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepEfficiencyDay">{{ allData.sleepInfo.secretsSleepEfficiencyDay.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepEfficiencyDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepEfficiencyDayDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
  
  
					<!-- 睡眠破碎统计_折线 -->
					<div class="txjyWrap border_no mt10">
					  <!--  -->
					  <!-- 睡眠破碎分布 -->
					  <div>
						<div class="txjyTit txjyTit_after_blue" style="">睡眠破碎指数分布</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">参考范围</div>
						  </div>
						  <div class="referValRight">
							<div class="gantTip">横轴为睡眠破碎指数</div>
						  </div>
						</div>
						<div id="ech_sleepRrush" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepCrush">{{ allData.sleepInfo.secretsSleepCrush.descLabel }}</div>
					  </div>
  
					  <!-- 睡眠破碎统计_折线 -->
					  <div class="">
						<div class="refer_comLine_heng"></div>
						<div class="txjyTit txjyTit_after_blue mt15" style="">每晚睡眠破碎指数</div>
						<div class="referVal">
						  <div class="referValLeft">
							<div class="gangKuai2_border"></div>
							<div class="gantTip">日常表现</div>
						  </div>
						</div>
						<div id="ech_sleepRrush_line" style="height: 150px;"></div>
						<div class="refer_comTit mt15" v-if="allData.sleepInfo.secretsSleepCrushDay">{{  allData.sleepInfo.secretsSleepCrushDay.descLabel }}</div>
  
						<!-- 是否发生偏离 -->
						<tan_needGz_portrait_botZheCont v-if="allData.sleepInfo.secretsSleepCrushDayDeviate" :haveChangeData="allData.sleepInfo.secretsSleepCrushDayDeviate"></tan_needGz_portrait_botZheCont>
					  </div>
					</div>
					
					<!-- 最下面的提醒建议 -->
					<tan_needGz_portrait_botAdvise :haveChangeData="allData.sleepInfo.conclusionRecommend"></tan_needGz_portrait_botAdvise>
  
					
				  </div>
				</div>

				<div style="width: 852px; height: 68px; background: rgba(255,255,255,0.8);; border-radius: 16px; border: 1px solid #FFFFFF; position: relative; margin-left: 12px; margin-top: 20px;">
					<div style="position: absolute; background: #F3F9F9; border-radius: 12px; border: 1px solid #B6EBDF; left: 5px; right: 5px; top: 5px; bottom: 5px; display: flex; justify-content: space-between; align-items: center;">
						<div style="display: flex; align-items: center;">
							<img style="width: 28px; height: 28px;  margin-left: 15px;" src="../../../assets/icon_dean_home_alert_icon_6.png" alt="" />
							<div style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #1F2635; line-height: 25px; margin-left: 10px;">{{ (incomingData && incomingData.healthReportDateCn ? incomingData.healthReportDateCn : '') + ' 睡眠报告' }}</div>
						</div>
						<div style="display: flex; align-items: center;">
							<img style="width: 17px; height: 17px; margin-right: 4px;" src="../../../assets/icon_dean_home_alert_icon_7.png" alt="" />
							<div style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: rgba(53, 192, 160, 1); line-height: 25px; margin-right: 15px;">{{ '指标全部正常' }}</div>
						</div>
					</div>
					<img style="width: 20px; height: 20px; position: absolute; left: -3px; top: -3px;" src="../../../assets/icon_dean_home_bg_card_icon_9.png" alt="" />
					<img style="width: 20px; height: 20px; position: absolute; right: -3px; bottom: -3px;" src="../../../assets/icon_dean_home_bg_card_icon_10.png" alt="" />
				</div>

			  </div>
			</div>
		  
		  </div>
		</div>
	  </div>
	</div>
  </template>
  
  <script>
  import portFn from '../../../utils/PortraitFunction.js';
  import CustomRichText from '../../../utils/CustomRichText.js';
  import tan_needGz_portrait_isHaveChange from './tan_needGz_portrait_isHaveChange.vue';     //昨晚是否有值得关注的变化
  import tan_needGz_portrait_botZheCont from './tan_needGz_portrait_botZheCont.vue';         //是否发生偏离
  import tan_needGz_portrait_botAdvise from './tan_needGz_portrait_botAdvise.vue';           //最下面的提醒建议
  
  import dataJson from './bbb.json'
  export default {
	components: { tan_needGz_portrait_isHaveChange,tan_needGz_portrait_botZheCont,tan_needGz_portrait_botAdvise },
	filters: {
	  reMate(val){
		return CustomRichText.reMate(portFn.function_reg_str_to_arr(val))
	  },
	},
	props: {
	  
	},
	watch: {
	  
	},
	data() {
	  return {
		innerHeight: null,
		bedId: '',
		new_rankList: [],
		tan_needGZ_single: false,
		hxqk_isExpand: true,     // 呼吸情况是否展开
		tdqk_isExpand: true,     // 体动情况是否展开
		xtqk_isExpand: true,     // 心跳情况是否展开
		zxgl_isExpand: true,     // 作息规律是否展开
		yjlc_isExpand: true,     // 夜间离床是否展开
		smqk_isExpand: true,     // 睡眠情况是否展开
  
  
		allData: null,           //数字画像接口数据
		isDomOver: null,
		
		incomingData: null, // 外部传入的数据
  
  
  
  
	  };
	},
	created() {},
	mounted() {
	  
	  
	},
	methods: {
	  // 外界调用这个组件
	  openAlert(data){
		console.log('浏览器窗口可见部分高度' + window.innerHeight)
		this.innerHeight = Number(window.innerHeight) - 66
		console.log('调用了数字画像')
		console.log(data)
		this.bedId = data.bedId
		this.incomingData = data;
		this.tan_needGZ_single = true;
  
		
		this.getDigitalPortraitBySnBedId()      //详情_数字画像
  
		this.$nextTick((res) =>{
  
		  // let mmm = portFn.function_reg_str_to_arr('<Warning/> 最近一天您的体动指数是<Text_R>23</Text_R>，明显和您日常的表现有较大差异')
		  // console.log(mmm)
		})
	  },
	  // 详情_数字画像
	  getDigitalPortraitBySnBedId(){
		this.hxqk_isExpand = true
		this.tdqk_isExpand = true
		this.xtqk_isExpand = true
		this.zxgl_isExpand = true
		this.yjlc_isExpand = true
		this.smqk_isExpand = true
		this.isDomOver = null
		console.log(788787)
		let obj = {
		  bedId: this.bedId
		  // bedId: '-123'
		  // bedId: '500'
		}
		this.$get(
		  'api/v4/home/getDigitalPortraitBySnBedId',
		  obj,
		  (res) => {
			if (res.code == 0) {
			  if (res.data) {
				console.log(res.data)
				this.allData = res.data;
  
				
				
  
				this.$nextTick((resNext) => {
				  // 呼吸情况
				  if(!res.data.breathInfo.unSecretsDays){
					// 呼吸率分布图
					let hxl_dis = {
					  name: '呼吸率',
					  xAxis: {
						data: this.allData.breathInfo.secretsBreath.xaxis
					  },
					  series: {
						data: this.allData.breathInfo.secretsBreath.data,
						range: this.allData.breathInfo.secretsBreath.range
					  },
					}
					// 吸呼比分布图
					let xhb_dis = {
					  name: '吸呼比',
					  xAxis: {
						data: this.allData.breathInfo.secretsInExRatio.xaxis
					  },
					  series: {
						data: this.allData.breathInfo.secretsInExRatio.data,
						range: this.allData.breathInfo.secretsInExRatio.range
					  },
					}
					this.getMyChart_optionBar('ech_breathOne','hxl_dis',hxl_dis)          //呼吸率分布
					this.getMyChart_optionBar('ech_breathTwo','xhb_dis',xhb_dis)         //吸呼比分布
				  }
				  // 体动情况
				  if(!res.data.bodyMoveInfo.unSecretsDays){
					// 体动分布图
					let td_dis = {
					  name: '体动指数',
					  xAxis: {
						data: this.allData.bodyMoveInfo.secretsBodyMoveIndex.xaxis
					  },
					  series: {
						data: this.allData.bodyMoveInfo.secretsBodyMoveIndex.data,
						range: this.allData.bodyMoveInfo.secretsBodyMoveIndex.range
					  },
					}
					// 体动破碎图
					let td_crush_line = {
					  xAxis: {
						data: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.xaxis
					  },
					  series: {
						data: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.data,
						range: this.allData.bodyMoveInfo.secretsBodyMoveIndexDay.range
					  },
					  avg: 10
					}
					this.getMyChart_optionBar('ech_tdOne','td_dis',td_dis)                //体动指数分布
					this.getMyChart_optionLine('ech_td_line','td_crush_line',td_crush_line, true)    //体动指数统计_折线
				  }
				  // 心跳情况
				  if(!res.data.heartInfo.unSecretsDays){
					// 心率分布图
					let heart_dis = {
					  name: '心率',
					  xAxis: {
						data: this.allData.heartInfo.secretsHeart.xaxis
					  },
					  series: {
						data: this.allData.heartInfo.secretsHeart.data,
						range: this.allData.heartInfo.secretsHeart.range
					  },
					}
					this.getMyChart_optionBar('ech_heartOne','heart_dis',heart_dis)             //心跳分布
				  }
				  // 作息规律
				  if(!res.data.dailyRoutineInfo.unSecretsDays){
  
					// 作息规律_上床入睡醒来起床散点图secretsDailyRoutine  未写
					let zxglArr = this.allData.dailyRoutineInfo.secretsDailyRoutine.data;
					let zxgl_highFreTime = this.allData.dailyRoutineInfo.secretsDailyRoutine.highFreTime;
					let zxgl_scRsXlQc_sandian = {
					  xAxis_data: this.function_get_all_mintues(),
					  yAxis_data: [],
					  series_data0: [],
					  series_data1: [],
					  series_data2: [],
					  series_data3: [],
					  scatter_interval1: [],
					  scatter_interval2: [],
					  scatter_interval3: [],
					  scatter_interval4: [],
					}
					for(let i = 0;i < zxglArr.length;i++){
					  // console.log(zxglArr[i])
					  zxgl_scRsXlQc_sandian.yAxis_data.push(zxglArr[i].date)
					  // zxgl_scRsXlQc_sandian.series_data0.push(zxglArr[i].getBed)
					  zxgl_scRsXlQc_sandian.series_data0.push([zxglArr[i].getBed,zxglArr[i].date])
					  zxgl_scRsXlQc_sandian.series_data1.push([zxglArr[i].sleepSt,zxglArr[i].date])
					  zxgl_scRsXlQc_sandian.series_data2.push([zxglArr[i].sleepEd,zxglArr[i].date])
					  zxgl_scRsXlQc_sandian.series_data3.push([zxglArr[i].leaveBed,zxglArr[i].date])
					}
					// 上床
					if(zxgl_highFreTime.getBedSt){
					  zxgl_scRsXlQc_sandian.scatter_interval1 = [[{'xAxis': zxgl_highFreTime.getBedSt},{'xAxis': zxgl_highFreTime.getBedEd}]]
					}
					// 入睡
					if(zxgl_highFreTime.sleepStSt){
					  zxgl_scRsXlQc_sandian.scatter_interval2 = [[{'xAxis': zxgl_highFreTime.sleepStSt},{'xAxis': zxgl_highFreTime.sleepStEd}]]
					}
					// 醒来
					if(zxgl_highFreTime.sleepEdSt){
					  zxgl_scRsXlQc_sandian.scatter_interval3 = [[{'xAxis': zxgl_highFreTime.sleepEdSt},{'xAxis': zxgl_highFreTime.sleepEdEd}]]
					}
					// 起床
					if(zxgl_highFreTime.leaveBedSt){
					  zxgl_scRsXlQc_sandian.scatter_interval4 = [[{'xAxis': zxgl_highFreTime.leaveBedSt},{'xAxis': zxgl_highFreTime.leaveBedEd}]]
					}
					// 前端自己增加是否显示作息规律中四个高频内容
					if(zxgl_highFreTime.getBedSt || zxgl_highFreTime.sleepStSt || zxgl_highFreTime.sleepEdSt || zxgl_highFreTime.leaveBedSt){
					  this.allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2 = true
					}else{
					  this.allData.dailyRoutineInfo.secretsDailyRoutine.isShow_highFreTime2 = false
					}
					// 作息规律_入睡时长分布图
					let zxgl_rssc_dis = {
					  name: '入睡时长',
					  xAxis: {
						data: this.allData.dailyRoutineInfo.secretsSleep.xaxis
					  },
					  series: {
						data: this.allData.dailyRoutineInfo.secretsSleep.data,
						range: this.allData.dailyRoutineInfo.secretsSleep.range
					  },
					}
					// 作息规律_入睡时长统计图
					let zxgl_rssc_dis2 = {
					  xAxis: {
						// data: [0,1,2,3]
						data: this.allData.dailyRoutineInfo.secretsSleepDay.xaxis
					  },
					  series: {
						data: this.allData.dailyRoutineInfo.secretsSleepDay.data,
						range: this.allData.dailyRoutineInfo.secretsSleepDay.range
						// data: [10,14,'3','32'],
						// range: [1,2]
					  },
					}
					// 作息规律_起床时长分布图
					let zxgl_qcsc_dis = {
					  name: '起床时长',
					  xAxis: {
						data: this.allData.dailyRoutineInfo.secretsBed.xaxis
					  },
					  series: {
						data: this.allData.dailyRoutineInfo.secretsBed.data,
						range: this.allData.dailyRoutineInfo.secretsBed.range
					  },
					}
					// 作息规律_起床时长统计图
					let zxgl_qcsc_dis2 = {
					  xAxis: {
						data: this.allData.dailyRoutineInfo.secretsBedDay.xaxis
					  },
					  series: {
						data: this.allData.dailyRoutineInfo.secretsBedDay.data,
						range: this.allData.dailyRoutineInfo.secretsBedDay.range
					  },
					}
					// id为echSanDian的dom滚动到底部
					let message = document.getElementById('id_echSanDian_wrap');
					message.scrollTop = message.scrollHeight;
  
					this.getMyChart_optionSca('echSanDian','zxgl_scRsXlQc_sandian',zxgl_scRsXlQc_sandian)         // 作息规律_上床入睡醒来起床散点图secretsDailyRoutine
					this.getMyChart_optionBar('ech_sleepOne','zxgl_rssc_dis',zxgl_rssc_dis)             //入睡时长分布
					this.getMyChart_optionBar('ech_sleepTwo','zxgl_rssc_dis2',zxgl_rssc_dis2)            //入睡时长统计
					this.getMyChart_optionBar('ech_getUpOne','zxgl_qcsc_dis',zxgl_qcsc_dis)             //起床时长分布
					this.getMyChart_optionBar('ech_getUpTwo','zxgl_qcsc_dis2',zxgl_qcsc_dis2)            //起床时长统计
				  }
				  
				  
  
				  // 夜间离床
				  if(!res.data.leaveBedInfo.unSecretsDays){
					// 夜间离床_离床次数分布图
					let yjlc_lccs_dis = {
					  name: '离床次数',
					  xAxis: {
						data: this.allData.leaveBedInfo.secretsLeaveBedTimes.xaxis
					  },
					  series: {
						data: this.allData.leaveBedInfo.secretsLeaveBedTimes.data,
						range: this.allData.leaveBedInfo.secretsLeaveBedTimes.range
					  },
					}
					// 夜间离床_离床次数统计图
					let yjlc_lccs_dis2 = {
					  xAxis: {
						data: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.xaxis
					  },
					  series: {
						data: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.data,
						range: this.allData.leaveBedInfo.secretsLeaveBedTimesDay.range
					  },
					}
					// 夜间离床_离床时长分布图
					if(this.allData.leaveBedInfo.secretsLeaveBedDuration){
					  let yjlc_lcsc_dis = {
						name: '离床时长',
						xAxis: {
						  data: this.allData.leaveBedInfo.secretsLeaveBedDuration.xaxis
						},
						series: {
						  data: this.allData.leaveBedInfo.secretsLeaveBedDuration.data,
						  range: this.allData.leaveBedInfo.secretsLeaveBedDuration.range
						},
					  }
					  this.getMyChart_optionBar('ech_outBedTimeOne','yjlc_lcsc_dis',yjlc_lcsc_dis)        //离床时长分布
					}
					// 夜间离床_上床入睡醒来起床散点图secretsDailyRoutine 
					if(this.allData.leaveBedInfo.secretsLeaveBedTimeDuration){
  
					  let yjlcArr = this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.data
					  let sc_rs_xl_qcData = {
						xAxis_data: this.function_get_all_mintues(),
						yAxis_data: [],
						series_data: [],
						scatter_interval: [],
						referenceList: this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.referenceList || []
					  }
					  for(let i = 0;i < yjlcArr.length;i++){
						sc_rs_xl_qcData.yAxis_data.push(yjlcArr[i].date)
						if(yjlcArr[i].timeDuration){
						  for(let j = 0;j < yjlcArr[i].timeDuration.length;j++){
							let aaa = [
							  yjlcArr[i].timeDuration[j].timeSt,
							  yjlcArr[i].date,
							  yjlcArr[i].timeDuration[j].duration
							]
							sc_rs_xl_qcData.series_data.push(aaa)
						  }
						  
						}
					  }
					  let yjlc_highFreTime = this.allData.leaveBedInfo.secretsLeaveBedTimeDuration.highFreTime;
					  if(yjlc_highFreTime){
						for(let i = 0;i < yjlc_highFreTime.length;i++){
						  let aaa = [
							{'xAxis': yjlc_highFreTime[i].timeSt},
							{'xAxis': yjlc_highFreTime[i].timeEd}
						  ]
						  sc_rs_xl_qcData.scatter_interval.push(aaa)
						}
					  }
  
					  // id为id_echSanDian_nightOutBed的dom滚动到底部
					  let message_OutBed = document.getElementById('id_echSanDian_nightOutBed');
					  message_OutBed.scrollTop = message_OutBed.scrollHeight;
					  this.getMyChart_optionSca2('echSanDian_nightOutBed','sc_rs_xl_qcData',sc_rs_xl_qcData)   //夜间离床散点
  
  
					}
  
					this.getMyChart_optionBar('ech_outBedNumOne','yjlc_lccs_dis',yjlc_lccs_dis)         //离床次数分布
					this.getMyChart_optionBar('ech_outBedNumTwo','yjlc_lccs_dis2',yjlc_lccs_dis2)        //离床次数统计
				  }
  
				  // 睡眠情况
				  if(!res.data.sleepInfo.unSecretsDays){
					// 睡眠情况_睡眠时长分布图
					let smqk_smsc_dis = {
					  name: '睡眠时长',
					  xAxis: {
						data: this.allData.sleepInfo.secretsSleepDuration.xaxis
					  },
					  series: {
						data: this.allData.sleepInfo.secretsSleepDuration.data,
						range: this.allData.sleepInfo.secretsSleepDuration.range
					  },
					}
					// 睡眠情况_睡眠时长统计图
					let smqk_smsc_dis2 = {
					  xAxis: {
						data: this.allData.sleepInfo.secretsSleepDurationDay.xaxis
					  },
					  series: {
						data: this.allData.sleepInfo.secretsSleepDurationDay.data,
						range: this.allData.sleepInfo.secretsSleepDurationDay.range
					  },
					}
					// 睡眠情况_睡眠效率分布图
					let smqk_smxl_dis = {
					  name: '睡眠效率',
					  xAxis: {
						data: this.allData.sleepInfo.secretsSleepEfficiency.xaxis
					  },
					  series: {
						data: this.allData.sleepInfo.secretsSleepEfficiency.data,
						range: this.allData.sleepInfo.secretsSleepEfficiency.range
					  },
					}
					// 睡眠情况_睡眠效率统计图
					let smqk_smxl_dis2 = {
					  xAxis: {
						data: this.allData.sleepInfo.secretsSleepEfficiencyDay.xaxis
					  },
					  series: {
						data: this.allData.sleepInfo.secretsSleepEfficiencyDay.data,
						range: this.allData.sleepInfo.secretsSleepEfficiencyDay.range
					  },
					}
					// 睡眠情况_睡眠破碎分布图
					let smqk_smps_dis = {
					  name: '睡眠破碎',
					  xAxis: {
						data: this.allData.sleepInfo.secretsSleepCrush.xaxis
					  },
					  series: {
						data: this.allData.sleepInfo.secretsSleepCrush.data,
						range: this.allData.sleepInfo.secretsSleepCrush.range
					  },
					}
					// 睡眠情况_睡眠破碎统计图
					let smqk_smps_dis2 = {
					  xAxis: {
						data: this.allData.sleepInfo.secretsSleepCrushDay.xaxis,
					  },
					  series: {
						data: this.allData.sleepInfo.secretsSleepCrushDay.data,
						range: this.allData.sleepInfo.secretsSleepCrushDay.range
					  },
					  // avg: res.data.median
					  avg: 10
					};
					this.getMyChart_optionBar('ech_sleepTimeOne','smqk_smsc_dis',smqk_smsc_dis)         //睡眠时长分布
					this.getMyChart_optionBar('ech_sleepTimeTwo','smqk_smsc_dis2',smqk_smsc_dis2)        //睡眠时长统计
					this.getMyChart_optionBar('ech_sleepEffOne','smqk_smxl_dis',smqk_smxl_dis)          //睡眠效率分布
					this.getMyChart_optionBar('ech_sleepEffTwo','smqk_smxl_dis2',smqk_smxl_dis2)         //睡眠效率统计
					this.getMyChart_optionBar('ech_sleepRrush','smqk_smps_dis',smqk_smps_dis)    //睡眠破碎分布
					this.getMyChart_optionLine('ech_sleepRrush_line','smqk_smps_dis2',smqk_smps_dis2)    //睡眠破碎统计
				  }
				})
  
				this.$forceUpdate()
				this.$nextTick((res2) => {
				  this.hxqk_isExpand = false
				  this.tdqk_isExpand = false
				  this.xtqk_isExpand = false
				  this.zxgl_isExpand = false
				  this.yjlc_isExpand = false
				  this.smqk_isExpand = false
				  // setTimeout(() => {
					this.isDomOver = true
				  // }, 100);
				  
				})
			  } 
			} else {
			  this.$message.error(res.msg);
			}
		  },
		  (err) => {
			console.log(err);
			// this.$message.error('服务端发生异常');
		  }
		);
	  },
  
  
  
  
	  // 公共柱状图
	  getMyChart_optionBar(idName, type, olddata) {
		let data = olddata
		// type  
		// 呼吸率分布hxl_dis  吸呼比分布xhb_dis  
		// 体动指数分布td_dis  
		// 心跳分布heart_dis  
		// 入睡时长分布zxgl_rssc_dis  入睡时长统计zxgl_rssc_dis2
		// 起床时长分布zxgl_qcsc_dis  起床时长统计zxgl_qcsc_dis2
		// 离床次数分布yjlc_lccs_dis  离床次数统计yjlc_lccs_dis2
		// 离床时长分布yjlc_lcsc_dis
		// 睡眠时长分布smqk_smsc_dis  睡眠时长统计smqk_smsc_dis2
		// 睡眠效率分布smqk_smxl_dis  睡眠效率统计smqk_smxl_dis2
		// 睡眠破碎分布smqk_smps_dis

		// 判断Y轴单位是否为小时
		let isYJudgeHours = false;
		let maxValue = 0;
		if (type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2') {
			if (data && data.series && data.series.data) {
				for (let i = 0; i < data.series.data.length; i++) {
					let item = data.series.data[i];
					if (item != '-') {
						if (parseInt(item) >= 60) {
							isYJudgeHours = true;
						}
						maxValue = item;
					}
				}
			}
		}
  
		// type  离床次数lccs  lccs2
		this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
		console.log(idName, type, data)
  
  
		// 判断是哪些类型的
		let allType;        //蓝色紫色区域范围都有的1   纯蓝色的2
		if(type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis'){
		  allType = 1
		}else {
		  allType = 2
		}
		let x1,x2;
  
		let xAxis_axisLabel_interval = 0;     //x轴最小间隔
		// 蓝色紫色区域范围都有的1
		if(allType == 1){
		  // 百分比处理
		  for(let i = 0;i < data.series.data.length;i++){
			data.series.data[i] = Math.round(data.series.data[i] * 100)
		  }
		  
		  // 柱状图bar颜色处理
		  if(data.series.range){
			for(let i = 0;i < data.xAxis.data.length;i++){
			  // 在范围内
			  if(Number(data.xAxis.data[i]) >= Number(data.series.range[0]) && Number(data.xAxis.data[i]) <= Number(data.series.range[1])){
				data.series.data[i] = {
				  value: data.series.data[i],
				  itemStyle: {color: '#1890FF'}
				}
			  }else {
				data.series.data[i] = {
				  value: data.series.data[i],
				  itemStyle: {color: '#B17DFF'}
				}
			  }
			}
		  }
		  
		  // 区间范围计算
		  let singleBarAreaWidth = 750 / data.xAxis.data.length;
		  let xAxis_data = data.xAxis.data;
		  let markArea_range = data.series.range
		  if (xAxis_data.indexOf(markArea_range[0]) != -1) {
			x1 = xAxis_data.indexOf(markArea_range[0]) * singleBarAreaWidth + 30;
		  }
		  if (xAxis_data.indexOf(markArea_range[1]) != -1) {
			x2 = xAxis_data.indexOf(markArea_range[1]) * singleBarAreaWidth + singleBarAreaWidth + 30;
		  }
		}else if(allType == 2){
		  x1 = 300
		  x1 = 500
		}
  
		if(type == 'smqk_smsc_dis' || type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'yjlc_lccs_dis2' || type == 'smqk_smsc_dis2' || type == 'smqk_smxl_dis2'){
		  xAxis_axisLabel_interval = 2
		}
  
  
		// 需要分钟转换小时分钟的
		let timeFonts = []
		if(type == 'zxgl_rssc_dis'){      //入睡时长分布
		  for(let i = 0;i < data.series.data.length;i++){
			if(data.series.data[i].value){
			  timeFonts.push(this.formaTime(data.series.data[i].value))
			}else{
			  timeFonts.push('-')
			}
			
		  }
		}
  
  
  
  
		let maxNum = Math.max(...data.series.data)
		// let yAxis_max = Math.round(maxNum / 10) * 10 + 10
		let yAxis_minInterval = 10
		let yAxis_max = null;
		if(type == 'smqk_smsc_dis2'){
		  yAxis_max = 720
		  yAxis_minInterval = 240
		}
		var optionBar = {
		  tooltip: {
			// show: false,
			trigger: 'axis',
			backgroundColor: 'rgba(255, 255, 255, 1)',
			borderColor: '#ABD7FF',
			borderWidth: 1,
			spanStyle: {
			  color: '#fff',
			},
			confine: true,
			borderRadius: 5,
			formatter: function(params) {
			  console.log(type);
			  console.log(params);
  
			  // 判断除了下面这些类型，剩余类型中params[0].data.value是否为undefined，如果是undefined，不显示浮窗（算法数据多给了一条导致）
			  if(!(type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'smqk_smsc_dis2' || type == 'yjlc_lccs_dis2' || type == 'smqk_smxl_dis2')){
				if(typeof params[0].data.value == 'undefined'){
				  return;
				}
			  }
			  if(type == 'xhb_dis' || type == 'td_dis' || type == 'smqk_smps_dis'){      //吸呼比分布  体动指数分布  破碎指标分布
				return (
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data.value + 
				  `%${data.name}集中`+
				  '<br/>' +
				  '<span style="margin-left:10px;"> 在' + params[0].axisValue + '</span>'
				);
			  } else if(type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lcsc_dis'){   //入睡时长分布  起床时长分布  离床时长分布
				return (
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data.value + 
				  `%${data.name}集中`+
				  '<br/>' +
				  '<span style="margin-left:10px;"> 在' + params[0].axisValue + '分钟</span>'
				);
			  } else if(type == 'yjlc_lccs_dis'){      //离床次数分布 
				return (
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data.value + 
				  `%${data.name}集中`+
				  '<br/>' +
				  '<span style="margin-left:10px;"> 在' + params[0].axisValue + '次</span>'
				);
			  } else if(type == 'hxl_dis' || type == 'heart_dis') {            //呼吸率分布  心率分布
				return (
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data.value + 
				  `%${data.name}集中`+
				  '<br/>' +
				  '<span style="margin-left:10px;"> 在' + params[0].axisValue + '次/分</span>'
				);
			  } else if(type == 'smqk_smxl_dis') {            //睡眠效率分布
				return (
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data.value + 
				  `%${data.name}集中`+
				  '<br/>' +
				  '<span style="margin-left:10px;"> 在' + params[0].axisValue + '%</span>'
				);
			  } else if(type == 'smqk_smsc_dis') {            //睡眠时长分布
				let hourMin = params[0].axisValue;
				if(hourMin < 60){
				  return (
					`<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
					params[0].data.value + 
					`%${data.name}集中`+
					'<br/>' +
					'<span style="margin-left:10px;"> 在' + hourMin + '分钟</span>'
				  );
				}else {
				  let nowTips = ''
				  if(hourMin % 60 == 0){
					nowTips += Math.floor(Number(hourMin) / 60) + '小时'
				  }else {
					nowTips += Math.floor(Number(hourMin) / 60) + '小时' + (hourMin % 60) + '分钟'
				  }
				  return (
					`<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
					params[0].data.value + 
					`%${data.name}集中`+
					'<br/>' +
					'<span style="margin-left:10px;"> 在' + nowTips +'</span>'
				  );
				}
			  } else if(type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2' || type == 'smqk_smsc_dis2'){          //入睡时长统计  起床时长统计  睡眠时长统计
				let hourMin = params[0].data;
				if (hourMin == '-') {
				  console.log('不存在params[0].data.value');
				  // return params[0].name + '<br/>' + '入睡时长' + '-' + '分钟';
				  return params[0].name + '<br/>' + '' + '-' + '分钟';
				} else {
				  console.log('存在params[0].data.value');
				  if (hourMin < 60) {
					return (
					  params[0].name +
					  '<br/>' +
					  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
					  (params[0].data.isEmpty ? '-' : hourMin) +
					  '分钟'
					);
				  } else {
					let nowTips = ''
					if(hourMin % 60 == 0){
					  nowTips += Math.floor(Number(hourMin) / 60) + '小时'
					}else {
					  nowTips += Math.floor(Number(hourMin) / 60) + '小时' + (hourMin % 60) + '分钟'
					}
					return (
					  params[0].name +
					  '<br/>' +
					  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
					  nowTips
					);
				  }
				}
			  } else if(type == 'yjlc_lccs_dis2'){      //离床次数统计
				return (
				  params[0].name +
				  '<br/>' +
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data +
				  '次'
				);
			  } else if(type == 'smqk_smxl_dis2'){      //睡眠效率统计
				return (
				  params[0].name +
				  '<br/>' +
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data +
				  '%'
				);
			  } else {
				return (
				  params[0].name + 
				  '<br/>' +
				  `<span style="background:${params[0].color};display:inline-block;border-radius:50%;width:8px;height:8px;margin-right:3px" ></span>` +
				  params[0].data + '分钟'
				);
			  }
			},
		  },
		  grid: {
			left: '0%',
			right: '0.5%',
			top: '10%',
			bottom: '1%',
			containLabel: true,
		  },
		  xAxis: [
			{
			  type: 'category',
			  data: data.xAxis.data,
			  axisLabel: {
				// interval: xAxis_axisLabel_interval,
				// spanStyle: {
				//   color: '', //坐标的字体颜色
				// },
				textStyle: {
				  color: '#5E6779',
				  fontSize:'10',
				  itemSize:'',
				},
				formatter(value,index) {
				  if(type == 'smqk_smsc_dis'){     //睡眠时长分布
					let surplus = value % 60;
					if (surplus == 0) {
					  return value / 60;
					}
					return '';
				  } else {
					return value
				  }
				}
  
			  },
			  axisLine: {
				lineStyle: {
				  color: '#9094A6',
				},
			  },
			  
			  axisTick: {
				show: false,
				// alignWithLabel: true,
			  },
			},
		  ],
		  yAxis: [
			{
			  max: yAxis_max,
			  type: 'value',
			  splitLine: {
				show: true,
				lineStyle: {
				  type: 'solid',
				  color: '#E4E6EC'
				}
			  },
			  minInterval: yAxis_minInterval, //设置最小间隔为1，防止出现小数
			  min: (type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2') && maxValue == 0 ? 5 : undefined,
			  axisLabel: {
				textStyle: {
				  color: '#5E6779',
				  fontSize:'10',
				  itemSize:''
				},
				formatter: function (value, index) {
				  if(type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis' || type == 'smqk_smxl_dis2'){
					return value + '%';
				  }else if(type == 'yjlc_lccs_dis2'){     //离床次数统计
					return value + '次';
				  }else {
					if (type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2') {
						if (isYJudgeHours) {
							if (value % 60 == 0) {
								return (value / 60) + 'h'
							}
						} else {
							if (value % 1 == 0) {
								return value + '分';
							}
						}
					} else {
						let val = Math.floor(Number(value) / 60) + 'h'
						return val
					}
				  }
				 
				}
			  },
			  axisLine: {
				lineStyle: {
				  color: '#c7c6c9',
				},
				show: false,
			  },
			  splitNumber: 3,
			  minInterval: (type == 'zxgl_rssc_dis2' || type == 'zxgl_qcsc_dis2') ? (isYJudgeHours ? 60 : undefined) : undefined
			},
		  ],
		  series: [
			{
			  data: data.series.data,
			  type: 'bar',
			  barWidth: 10,
			  itemStyle: {
				normal: {
				  //柱形图圆角，初始化效果
				  barBorderRadius: [4, 4, 0, 0],
				  color: '#1890FF'
				},
			  },
			  markArea: type == 'hxl_dis' || type == 'xhb_dis' || type == 'td_dis' || type == 'heart_dis' || type == 'zxgl_rssc_dis' || type == 'zxgl_qcsc_dis' || type == 'yjlc_lccs_dis' || type == 'yjlc_lcsc_dis' || type == 'smqk_smsc_dis' || type == 'smqk_smxl_dis' || type == 'smqk_smps_dis' ?{
				silent:true,
				data: [
				  [
					{ x: x1, },
					{ x: x2, },
				  ],
				],
				itemStyle: {
				  borderType: 'dashed',
				  borderColor: '#1890FF',
				  borderWidth: 1,
				  color: 'rgba(24,144,255,0.05)',
				}
			  } : {
				silent:true,
				data: [
				  [
					{ yAxis: data.series.range[0], },
					{ yAxis: data.series.range[1], },
				  ],
				],
				itemStyle: {
				  borderType: 'dashed',
				  borderColor: '#1890FF',
				  borderWidth: 1,
				  color: 'rgba(24,144,255,0.05)',
				}
			  },
			}
			
		  ]
		}
		this.myChart_Bar.setOption(optionBar,true);
		window.addEventListener('resize', () => {
		  this.myChart_Bar.resize();
		});
		this.$forceUpdate()
	  },
	  // 公共折线图
	  getMyChart_optionLine(idName, type, olddata, isMax) {
		let data = olddata
		// 体动指数统计_折线td_crush_line  睡眠破碎统计smqk_smps_dis2
		this.myChart_Line = this.$echarts.init(document.getElementById(idName));
		console.log(idName, type, data)
  
		let maxNum = Math.max(...data.series.data)
		let yAxis_max = Math.round(maxNum / 10) * 10 + 10
		
  
		let grid_left = '0.5%'
		let grid_bottom = '1%'
  
		if(type == 'td_crush_line'){             //体动指数统计_折线
		  yAxis_max = null
		  grid_left = '1%'
		} else if(type == 'smqk_smps_dis2'){    //睡眠破碎统计
		  yAxis_max = null
		} 
		var optionLine = {
		  tooltip: {
			trigger: 'axis',
			backgroundColor: 'rgba(255, 255, 255, 1)',
			borderColor: '#ABD7FF',
			borderWidth: 1,
			spanStyle: {
			  color: '#fff',
			},
			confine: true,
			borderRadius: 5,
			formatter: function(params) {
			  console.log(type);
			  console.log(params);
			  // if (type == 'bjbl') {      //报警比例
				return (
				  // params[0].name +
				  // '<br/>' +
				  // '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
				  // params[0].data + '%'
  
  
				  params[0].name +
				  '<br/>' +
				  '<span style="background:#2e90ff;display:inline-block;border-radius:50%;width:10px;height:10px;margin-right:3px" ></span>' +
				  params[0].data 
				);
			  // } 
			},
		  },
		  grid: {
			left: grid_left,
			// left: '0%',
			right: '0.5%',
			top: '15%',
			bottom: grid_bottom,
			containLabel: true,
		  },
		  xAxis: [
			{
			  type: 'category',
			  data: data.xAxis.data,
			  axisLabel: {
				// interval: 10,
				// spanStyle: {
				//   color: '', //坐标的字体颜色
				// },
				textStyle: {
				  color: '#5E6779',
				  fontSize:'10',
				  itemSize:'',
				},
				show: type == 'bjbl' ? false : true
			  },
			  axisLine: {
				lineStyle: {
				  color: '#9094A6',
				},
			  },
			  
			  axisTick: {
				show: false,
				// alignWithLabel: true,
			  },
			},
		  ],
		  yAxis: [
			{
			  max: yAxis_max,
			  type: 'value',
			  splitLine: {
				show: true,
				lineStyle: {
				  type: 'dashed',
				  color: '#CACDD9'
				}
			  },
			  // minInterval: 1100, //设置最小间隔为1，防止出现小数
			  minInterval: 1, //设置最小间隔为1，防止出现小数
			  axisLabel: {
				// spanStyle: {
				//   color: '#5E6779', //坐标的字体颜色
				// },
				textStyle: {
				  color: '#5E6779',
				  fontSize:'10',
				  itemSize:''
				}
			  },
			  axisLine: {
				lineStyle: {
				  color: '#c7c6c9',
				},
				show: false,
			  },
			  splitNumber: 1,
			  max: isMax ? 100 : undefined,
			  min: isMax ? 0 : undefined
			},
		  ],
		  series: [
			{
			  data: data.series.data,
			  type: 'line',
			  barWidth: 20,
			  // symbol: 'none',
			  lineStyle:{           //线条颜色
				color:'#1890FF'
			  },
			  // smooth: true,         //平滑处理
			  symbol: 'circle',
			  showSymbol: type == 'bjbl' ? false : true,
			  symbolSize: 8,
			  color: '#1890FF',
			  areaStyle: type == 'seven_bjbl' || type == 'bbbb' ? {
				color: {
				  type: 'linear',
				  x: 0,
				  y: 0,
				  x2: 0,
				  y2: 1,
				  colorStops: [
					{
					  offset: 0,
					  color: 'rgba(24, 144, 255, 0.4)', // 0% 处的颜色
					},
					{
					  offset: 1,
					  color: 'rgba(24, 144, 255, 0.05)', // 100% 处的颜色
					},
				  ],
				  global: false, // 缺省为 false
				},
			  } : null,
			  markLine: type == 'bbbb' ? {
				symbol: 'none',
				emphasis: {
				  lineStyle: {
					width: 1, // hover时的折线宽度
				  },
				},
				data: [
				  {
					silent: false, //鼠标悬停事件  true没有，false有
					lineStyle: {
					  //警戒线的样式  ，虚实  颜色
					  type: 'dashed',
					  color: '#63B2FB',
					},
					label: {
					  position: 'end',
					  formatter: '',
					},
					yAxis: data.avg, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
				  },
				],
			  } : null,
			  markArea: {
				silent:true,
				data: [
				  [
					{
					  name: '',
					  yAxis: data.series.range[0],
					  // yAxis: 10,
					  itemStyle: {
						color: 'rgba(24,144,255,0.05)',
					  },
					},
					{
					  yAxis: data.series.range[1],
					  // yAxis: 40,
					},
				  ],
				],
				itemStyle: {
					borderType: 'dashed',
					borderColor: '#1890FF',
					borderWidth: 1,
					color: 'rgba(24,144,255,0.05)',
				}
			  } 
			}
			
		  ]
		}
		this.myChart_Line.setOption(optionLine,true);
		window.addEventListener('resize', () => {
		  this.myChart_Line.resize();
		});
		this.$forceUpdate()
	  },
  
	  // 公共散点图_作息规律上床入睡醒来起床
	  getMyChart_optionSca(idName, type, olddata){
		let data = olddata
		console.log(idName, type, olddata)
		this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
		let xAxis_data = data.xAxis_data
		let yAxis_data = data.yAxis_data
		let series_data0 = data.series_data0
		let series_data1 = data.series_data1
		let series_data2 = data.series_data2
		let series_data3 = data.series_data3
		let scatter_interval1 = data.scatter_interval1
		let scatter_interval2 = data.scatter_interval2
		let scatter_interval3 = data.scatter_interval3
		let scatter_interval4 = data.scatter_interval4
  
  
		let optionBar = {
		  tooltip: {
			type: 'none',
			axisPointer: { // 十字
			  type: 'cross',
			  snap: false,
			  animation: true,
			  label: {
				color: '#FFFFFF',
				backgroundColor: '#5F64E7',
				opacity: 1
			  },
			  crossStyle: {
				color: '#BCB6E8',
				width: 1
			  }
			},
			backgroundColor: "#FFFFFF",
			borderColor: "#ABD7FF",
			borderWidth: 1,
			borderRadius: 5,
			textStyle: {
			  color: "#262626",
			},
			confine: true,
			formatter: function (val) {
			  return val.seriesName + '<br/>' + val.marker + val.value[1] + '为' + val.value[0].toString();
			}
		  },
		  xAxis: [
			{
			  position: 'top',
			  axisLabel: {
				show: false
			  },
			  axisLine: {
				show: false
			  },
			  axisTick: {
				show: false
			  },
			  data: xAxis_data,
			}
		  ],
		  yAxis: [
			{
			  axisLine: {
				show: false
			  },
			  axisLabel: {
				color: '#A5A9BC',
			  },
			  axisTick: {
				show: false
			  },
			  inverse: true, // 反转
			  data: yAxis_data,
			  splitArea: {
				show: true,
				interval: 'auto',
				areaStyle: {
				}
			  }
			}
		  ],
		  grid: {
			x: 12,
			y: -1,
			x2: 12,
			y2: 1,
			containLabel: true
		  },
		  series: [
			{
			  name: '上床时间',
			  data: series_data0,
			  type: 'scatter',
			  symbol: 'circle',
			  symbolSize: [6 , 6],
			  itemStyle: {
				normal: {
				  color: '#FF7186'
				},
			  },
			  showBackground: true,
			  backgroundStyle: {
				color: 'red'
			  },
			  markArea: {
				itemStyle: {
				  color: '#FF718630'
				},
				data: scatter_interval1
			  }
			},
			{
			  name: '入睡时间',
			  data: series_data1,
			  type: 'scatter',
			  symbol: 'circle',
			  symbolSize: [6 , 6],
			  itemStyle: {
				normal: {
				  color: '#FFB971'
				},
			  },
			  showBackground: true,
			  backgroundStyle: {
				color: 'red'
			  },
			  markArea: {
				itemStyle: {
				  color: '#FAAB6230'
				},
				data: scatter_interval2
			  }
			},
			{
			  name: '醒来时间',
			  data: series_data2,
			  type: 'scatter',
			  symbol: 'circle',
			  symbolSize: [6 , 6],
			  itemStyle: {
				normal: {
				  color: '#44D7B6'
				},
			  },
			  showBackground: true,
			  backgroundStyle: {
				color: '#FF7186'
			  },
			  markArea: {
				itemStyle: {
				  color: '#44D7B630'
				},
				data: scatter_interval3
			  }
			},
			{
			  name: '起床时间',
			  data: series_data3,
			  type: 'scatter',
			  symbol: 'circle',
			  symbolSize: [6 , 6],
			  itemStyle: {
				normal: {
				  color: '#1890FF'
				},
			  },
			  showBackground: true,
			  backgroundStyle: {
				color: 'red'
			  },
			  markArea: {
				itemStyle: {
				  color: '#1890FF30'
				},
				data: scatter_interval4
			  }
			}
		  ],
		  // dataZoom: [
		  //   {
		  //     type: 'inside',
		  //     orient: 'vertical',
		  //     start: 100,
		  //     maxValueSpan: 6,
		  //     minValueSpan: 6,
		  //     zoomLock: true,
		  //   }
		  // ]
		};
		this.myChart_Bar.setOption(optionBar,true);
		window.addEventListener('resize', () => {
		  this.myChart_Bar.resize();
		});
		this.$forceUpdate()
	  },
	  // 公共散点图_夜间离床
	  getMyChart_optionSca2(idName, type, olddata){
		let data = olddata
		console.log('散点夜间离床')
		console.log(idName, type, olddata)
		this.myChart_Bar = this.$echarts.init(document.getElementById(idName), null, { renderer: 'svg' });
		let xAxis_data = data.xAxis_data
		let yAxis_data = data.yAxis_data
		let series_data = data.series_data
		let scatter_interval = data.scatter_interval
		let referenceList = data.referenceList
  
  
		let optionBar = {
		  tooltip: {
			type: 'none',
			axisPointer: { // 十字
			  type: 'cross',
			  snap: false,
			  animation: true,
			  label: {
				color: '#FFFFFF',
				backgroundColor: '#5F64E7',
				opacity: 1
			  },
			  crossStyle: {
				color: '#BCB6E8',
				width: 1
			  }
			},
			backgroundColor: "#FFFFFF",
			borderColor: "#ABD7FF",
			borderWidth: 1,
			borderRadius: 5,
			textStyle: {
			  color: "#262626",
			},
			confine: true,
			formatter: function (val) {
			  console.log(val)
			  let value = val.value;
					  return value[1] + ' ' + value[0] + '<br/>' + val.marker + '离床' + value[2] + '分钟';
			}
		  },
		  xAxis: [
			{
			  position: 'top',
			  axisLabel: {
				show: false
			  },
			  axisLine: {
				show: false
			  },
			  axisTick: {
				show: false
			  },
			  data: xAxis_data,
			}
		  ],
		  yAxis: [
			{
			  axisLine: {
				show: false
			  },
			  axisLabel: {
				color: '#A5A9BC',
			  },
			  axisTick: {
				show: false
			  },
			  inverse: true, // 反转
			  data: yAxis_data,
			  splitArea: {
				show: true,
				interval: 'auto',
				areaStyle: {
				}
			  }
			}
		  ],
		  grid: {
			x: 12,
			y: -1,
			x2: 12,
			y2: 1,
			containLabel: true
		  },
		  series: [
			{
			  name: '离床时长',
			  data: series_data,
			  type: 'scatter',
			  symbol: function (val) {
				if (val[2] <= 5) {
				  return 'rect';
				}
				return 'rect';
			  },
			  symbolSize: function (val) {
				// let allMinutes = 13 * 60.0;
				// let screenWidth = formatterVariable.screenWidth;
				// let singleWidth = screenWidth / allMinutes;
				let singleWidth = 711/720
				if (val[2] <= 5) {
				  return [5, 5];
				}
				return [6 + (val[2] * singleWidth) , 6];
			  },
			  symbolOffset: ['50%', 0],
			  itemStyle: {
				normal: {
				  color: function (val) {
					// let referenceList = formatterVariable.referenceList || [];
					let colors = [
					  'rgba(78, 66, 199, 1)',
					  'rgba(76, 96, 196, 1)',
					  'rgba(74, 125, 193, 1)',
					  'rgba(72, 155, 189, 1)',
					  'rgba(70, 184, 185, 1)',
					  'rgba(68, 214, 182, 1)',
					  'rgba(103, 209, 169, 1)',
					  'rgba(140, 204, 156, 1)',
					  'rgba(177, 198, 142, 1)',
					  'rgba(213, 192, 128, 1)',
					  'rgba(250, 186, 115, 1)'
					];
					for (let i = 0; i < referenceList.length; i++) {
					  let item = referenceList[i];
					  if (i == referenceList.length - 1) {
						return colors[10];
					  } else {
						if (val.value[2] >= Number(item) && val.value[2] < referenceList[i + 1]) {
						  return colors[i];
						}
					  }
					}
					return colors[16];
				  }
				},
			  },
			  showBackground: true,
			  markArea: {
				itemStyle: {
				  color: '#4E3EC810'
				},
				data: scatter_interval
			  }
			}
		  ],
		  // dataZoom: [
		  //   {
		  //     type: 'inside',
		  //     orient: 'vertical',
		  //     start: 100,
		  //     maxValueSpan: 6,
		  //     minValueSpan: 6,
		  //     zoomLock: true,
		  //   }
		  // ]
		};
		this.myChart_Bar.setOption(optionBar,true);
		window.addEventListener('resize', () => {
		  this.myChart_Bar.resize();
		});
		this.$forceUpdate()
	  },
	  // 时间方法 720个点
	  function_get_all_mintues() {
		let hours_data = [19, 20, 21, 22, 23, 0, 1, 2, 3, 4, 5, 6, 7, 8];
		let times = [];
		let minutes = [];
		for (let i = 0; i < hours_data.length; i++) {
		  let needTime;
		  let item = hours_data[i];
		  for (let j = 0; j <= 59; j++) {
			if (item == 19) {
			  if (j >= 30) {
				let tempHours = item > 9 ? item : '0' + item;
				let tempMinutes = j > 9 ? j : '0' + j;
				needTime = tempHours + ':' + tempMinutes;
				times.push(needTime);
				minutes.push(item * 60 + j);
			  }
			} else if (item == 8) {
			  if (j <= 30) {
				let tempHours = item > 9 ? item : '0' + item;
				let tempMinutes = j > 9 ? j : '0' + j;
				needTime = tempHours + ':' + tempMinutes;
				times.push(needTime);
				minutes.push(item * 60 + j);
			  }
			} else {
			  let tempHours = item > 9 ? item : '0' + item;
			  let tempMinutes = j > 9 ? j : '0' + j;
			  needTime = tempHours + ':' + tempMinutes;
			  times.push(needTime);
			  minutes.push(item * 60 + j);
			}
		  }
		}
		return times;
	  },
	  formaTime(minutes) {
		return Math.floor(minutes / 60) + '小时' + (minutes % 60) + '分钟';
	  },
  
  
	  
	},
  };
  </script>
  <style lang="scss" scoped>
  @import '../../../assets/css/comHome.scss';
  
  .needChangeWrap{
	width: 852px;
	height: 54px;
	background: #FFFFFF;
	border-radius: 2px;
	backdrop-filter: blur(8px);
	padding: 0 20px;
	box-sizing: border-box;
	margin-top: 10px;
	position: relative;
	display: flex;
	align-items: center;
	.needChangeTip{
	  font-size: 18px;
	  font-family: PingFangSC-Regular, PingFang SC;
	  font-weight: 400;
	  color: #1F2635;
	}
  }
  .needChangeWrap::after{
	width: 4px;
	height: 20px;
	background: #FF7186;
	border-radius: 0px 2px 2px 0px;
  
	content: '';
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
  }
  // 发现几项值得关注的变化
  .gzVaryWrap{
	width: 850px;
	height: 54px;
	background: #FCEBEE;
	border-radius: 4px;
	border: 1px solid #FFB8C3;
	backdrop-filter: blur(8px);
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 10px auto 0;
	.gBellImg{
	  width: 18px;
	  height: 18px;
	  margin-right: 5px;
	}
	.name{
	  font-size: 14px;
	  font-family: PingFangSC-Regular, PingFang SC;
	  font-weight: 400;
	  color: #5E6779;
	}
  }
  // .tan_needGz_portraitWrap{
  //   width:auto;
  //   height: auto;
  //   position:relative;
  //   left: -24px;
  //   // top: -24px;
  //   top: -79px;
  //   background: none;
  //   z-index: 999;
  //   .needGZ_One_Tan{
  //     position: static;
  //     max-height: none;
  //     left: 0;
  //     top: 0;
  //     transform: none;
  //   }
  // }
  
  .needGZ_TanWrap{
	width: 100%;
	height: 100%;
	position: fixed;
	left: 0;
	top: 0;
	background: rgba(0,0,0,0.5);
	z-index: 999;
	.needGZ_Tan{
	  width: 900px;
	  height: auto;
	  background: rgba(236, 240, 243, 1) !important;
	  border-radius: 4px;
	  position: fixed;
	  left: 50%;
	  top: 50%;
	  transform: translate(-50%,-50%);
	  padding-bottom: 30px;
  
	  min-height: 600px;
	  max-height: 800px;
	  overflow: auto;
	}
  }
  
  .tan_needGz_portraitWrap ::v-deep {
	.hx_overview1{
	  width: 850px;
	  min-height: 80px;
	  height: auto;
	  z-index: 999;
	  padding-left: 225px;
	  padding-right: 15px;
	  padding-top: 10px;
	  box-sizing: border-box;
	  margin-top: 100px;
	  background: url("../../../assets/icon_work_proposal_icon_15.png") no-repeat !important;
  	  background-size: 850px 100% !important;
	  .bot_adv_tag{
		padding: 1px 10px 1px 5px;
		background: #FFE0E4;
		border-radius: 19px;
		border: 1px solid #FFB8C3;
		backdrop-filter: blur(8px);
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #5E6779;
  
		display: inline-block;
  
		.tanhaoIcon{
		  width: 14px;
		  height: 14px;
		  // margin-right: 3px;
		  margin-top: -3px;
		}
	  }
	}
	.bot_adv_tag2{
	  font-size: 14px;
	  padding: 2px 10px;
	  background: #E0F0FF;
	  border-radius: 19px;
	  border: 1px solid #B7DCFE;
	  backdrop-filter: blur(8px);
	  display: inline-block;
	}
	.refer_comTit2{
	  width: 780px;
	  height: 52px;
	  font-size: 16px;
	  font-family: PingFangSC-Regular, PingFang SC;
	  font-weight: 400;
	  color: #1F2635;
	  background: #FFFFFF;
	  border-radius: 4px;
	  border: 1px solid rgba(255,113,134,0.5);
	  padding: 0 15px;
	  box-sizing: border-box;
	  // display: flex;
	  align-items: center;
	  .reIcon{
		width: 15px;
		height: 15px;
		margin-top: -2px;
		// margin-right: 5px;
	  }
	}
	.zxWrap{
	  height: 30px;
	  position: relative;
	  .zxLine{
		width: 750px;
		height: 2px;
		background: #FFD4DA;
		border-radius: 3px;
		position: absolute;
		left: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		.zxCirWrap{
		  flex:1;
		  display: flex;
		  justify-content: center;
		  .zxCir{
			width: 12px;
			height: 12px;
			border-radius: 50%;
			cursor: pointer;
			position: relative;
			.red_cir_noSel{
			  width: 100%;
			  height: 100%;
			  position: absolute;
			  left: 0;
			  top: 0;
			}
			.red_cir_Sel{
			  display: none;
			}
			.zxCirFloWin{
			  // width: 93px;
			  height: auto;
			  background: rgba(255,255,255,0.8);
			  border: 1px solid #FFDDE2;
			  backdrop-filter: blur(2px);
			  padding: 15px;
			  position: absolute;
			  top: -80px;
			  left: 50%;
			  transform: translateX(-50%);
			  display: none;
			  .ai_image_change_triangle_d{
				width: 10px;
				height: 8px;
				position: absolute;
				bottom: -6px;
				left: 50%;
				transform: translateX(-50%);
			  }
			  .time{
				// width: auto;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #262626;
				white-space: nowrap;
			  }
			  .tCir{
				width: 8px;
				height: 8px;
				background: #FF7186;
				border-radius: 50%;
				margin-right: 3px;
			  }
			}
		  }
		  .zxCir:hover .red_cir_Sel{
			display: block;
		  }
		  .zxCir:hover .zxCirFloWin{
			display: block;
		  }
		}
	  }
	}
  }

  .portrait_Cont::-webkit-scrollbar {
    display: none
  }

  
  </style>
  